export default "__VITE_ASSET__fef5ef36__"